import { gql } from 'graphql-request'

export namespace FavoriteQueries {
  export namespace GET {
    export type Response = { bookablePerson: { favorites: Favorite[] | null } | null }
  }

  export function getFavorites() {
    return gql`
      query getBookablePersonFavorites($bookablePersonRecord: BookablePersonRecord) {
        bookablePerson(bookablePersonRecord: $bookablePersonRecord) {
          favorites {
            id
            homeId
            state
            unitName
            baths
            bedrooms
            squareFootage
            displayCitySlug
          }
        }
      }
    `
  }
}

export interface Favorite {
  baths: number
  bedrooms: number | null
  displayCitySlug: string | null
  homeId: number
  id: number
  squareFootage: number | null
  state: string | null
  unitName: string | null
}
